import React from 'react';
import { connect } from 'react-redux';
import { bookFollow, bookUnfollow } from '../../actions/booksActions';
import PropTypes from 'prop-types';
import Spinner from '../shared/_Spinner';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

class FollowBook extends React.Component {
  state = {
    loading: false,
    transition: false
  }
  _handleFollowBook = () => {
    const { followBook, bookId } = this.props;

    this.setState({ loading: true, transition: true  }, () => {
      followBook({ bookId });
    });
  };

    _handleUnfollowBook = () => {
      const { unfollowBook, bookId } = this.props;

      this.setState({ loading: true, transition: true  }, () => {
        unfollowBook({ bookId });
      });
    };

    componentDidUpdate(prevProps, prevState) {
      const { booksLoading, status } = this.props;
      const { loading } = this.state;

      if (prevProps.booksLoading !== booksLoading && status === 'success' && loading) {
        this.setState({ loading: false });
      }
    }
    render() {
      const { followed, customClass = '', booksLoading  } = this.props;
      const { loading, transition } = this.state;
      const enabled = loading && booksLoading;

      return (
        <Spinner className={ 'follow__spinner' } enabled={ enabled }>
          <ReactCSSTransitionGroup transitionAppear={ transition }
            transitionAppearTimeout={ 500 }
            transitionEnter={ false }
            transitionLeave={ false }
            transitionName='example'>
            <div className={ `follow hover ${customClass}` }>
              {followed ?
                <React.Fragment>
                  <i aria-hidden='true' className='fa fa-star follow__icon' onClick={ this._handleUnfollowBook } />
                  <span className='hover__text'>Unfollow a book</span>
                </React.Fragment> :
                <React.Fragment>
                  <i aria-hidden='true' className='fa fa-star-o follow__icon' onClick={ this._handleFollowBook } />
                  <span className='hover__text' > Follow a book</span>
                </React.Fragment>
              }
            </div>
          </ReactCSSTransitionGroup>
        </Spinner>
      );
    }
}

FollowBook.propTypes = {
  bookId: PropTypes.string.isRequired,
  booksLoading: PropTypes.bool,
  customClass: PropTypes.string,
  followBook: PropTypes.func.isRequired,
  followed: PropTypes.bool.isRequired,
  status: PropTypes.string,
  unfollowBook: PropTypes.func.isRequired

};

const mapStateToProps = (state) => {
  return {
    booksLoading: state.getIn(['books', 'loading']),
    status: state.getIn(['books', 'status'])

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    followBook: ({ bookId }) => dispatch(bookFollow({ bookId })),
    unfollowBook: ({ bookId }) => dispatch(bookUnfollow({ bookId }))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FollowBook);



// WEBPACK FOOTER //
// ./app/components/reps/FollowBook.jsx